import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CLOSE_SEARCHBAR } from "../../../store/actions";
import SearchIcon from "../../../../../assets/icons/searchicon1";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { navigateTo } from "../../../../arrow/utils/utils";

import "./search-overlay.m.css";
import CloseIcon from "../../../atoms/CloseIcon";

const SearchOverlay = () => {
  const dispatch = useDispatch();
  const isSearchBarOpen = useSelector(state => state.isSearchBarOpen);
  const [searchQuery, setSearchQuery] = useState("");
  const inputRef = useRef(null);

  // Focus input when overlay opens
  useEffect(() => {
    if (isSearchBarOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isSearchBarOpen]);

  // Handle escape key to close overlay and manage body classes
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === "Escape" && isSearchBarOpen) {
        closeSearchOverlay();
      }
    };
    
    if (isSearchBarOpen) {
      document.addEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "hidden";
      document.body.classList.add("search-overlay-open");
    } else {
      document.body.style.overflow = "unset";
      document.body.classList.remove("search-overlay-open");
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "unset";
      document.body.classList.remove("search-overlay-open");
    };
  }, [isSearchBarOpen]);

  const closeSearchOverlay = () => {
    dispatch({ type: CLOSE_SEARCHBAR, isSearchBarOpen: false });
    setSearchQuery("");
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Navigate to search page with query parameter
      navigateTo(dispatch, `/search?q=${encodeURIComponent(searchQuery.trim())}`);
      closeSearchOverlay();
    }
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    inputRef.current?.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchSubmit(e);
    }
  };



  if (!isSearchBarOpen) return null;

  return (
    <div styleName="search-overlay">
      <div styleName="content-wrapper">
         <div styleName="search-overlay-content">
          <div styleName="search-header">
            <h2 styleName="search-title">Search</h2>
          </div>
        
          <form styleName="search-form" onSubmit={handleSearchSubmit}>
            <div styleName="search-input-wrapper">
              <div styleName="search-icon">
                <SearchIcon />
              </div>
              <input
                ref={inputRef}
                type="text"
                styleName="search-input"
                placeholder="e.g. executive briefings"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button
                  type="button"
                  styleName="clear-button"
                  onClick={handleClearSearch}
                  aria-label="Clear search"
                >
                  <CloseIcon color="#8F8F8F" strokeWidth="1.25" />
                </button>
            </div>
          </form>
        </div>
        <button
          styleName="close-button"
          onClick={() => closeSearchOverlay()}
          aria-label="Close search"
        >
          <CloseIcon color="#242424" strokeWidth="1.25" />
        </button>
      </div>
      <div styleName="outside-click" onClick={() => closeSearchOverlay()} />
    </div>
  );
};

export { SearchOverlay };
